import {Inject, Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment-timezone';
import * as _ from 'lodash';

@Pipe({
  standalone: false,
  name: 'planningActivityTimeWindow'
})
export class PlanningActivityTimeWindowPipe implements PipeTransform {

  constructor(@Inject('splitService') private splitService) {}

  transform(time: any, timeZoneId?: string): string {
    const from = _.get(time, 'eta');
    const to = _.get(time, 'etd');

    if (from && to) {
      const config = this.splitService.getDateAndTimeConfig();

      let isSameDate;
      let isSameTime;
      if (timeZoneId) {
        isSameDate = moment.tz(from, timeZoneId).isSame(moment.tz(to, timeZoneId), 'day');
        isSameTime = moment.tz(from, timeZoneId).isSame(moment.tz(to, timeZoneId), 'minute');
      } else {
        isSameDate = moment(from).isSame(moment(to), 'day');
        isSameTime = moment(from).isSame(moment(to), 'minute');
      }

      // If both date and time are the same, show only one time
      if (isSameDate && isSameTime) {
        return this.doDateFilter(from, config, timeZoneId) + ', ' + this.doTimeFilter(from, config, timeZoneId);
      }

      return isSameDate ?
        this.doDateFilter(from, config, timeZoneId) + ', ' + this.doTimeFilter(from, config, timeZoneId) + ' - ' + this.doTimeFilter(to, config, timeZoneId) :
        this.doDateFilter(from, config, timeZoneId) + ', ' + this.doTimeFilter(from, config, timeZoneId) + ' - ' + this.doDateFilter(to, config, timeZoneId) + ', ' + this.doTimeFilter(to, config, timeZoneId);
    } else {
      return '---';
    }
  }

  private doTimeFilter(date: any, config: any, timeZoneId: string): string {
    const format = config.time;
    if (timeZoneId) {
      return moment.tz(date, timeZoneId).format(format || 'HH:mm');
    } else {
      return moment(date).format(format || 'HH:mm');
    }
  }

  private doDateFilter(date: any, config: any, timeZoneId: string): string {
    const format = config.date;
    if (timeZoneId) {
      return moment.tz(date, timeZoneId).format(format || 'MM-DD');
    } else {
      return moment(date).format(format || 'MM-DD');
    }
  }
}
